import { Component, AfterViewInit,Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { ServiceRepository } from '../service-repository';
import {ErrorModel} from'../../Model/error/error-model';

import { Observable, throwError ,Subject} from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { AnySoaRecord } from 'dns';
;

@Injectable({
  providedIn: 'root'
})
export class ErrorServiceService {
  data : Subject<any> = new Subject<any>();
  _value!:string;

  


  constructor(
    private _repositoryService: ServiceRepository
  ) {

   }

   handleError(error:Response | any , errModal: ErrorModel) {
    let errorMessage = '';
    let customError="";
   

    if(error instanceof HttpErrorResponse){
      if((<HttpErrorResponse> error).status==0){
        customError="ERR_CONNECTION_REFUSED";
        
      }
      errorMessage ='HTTP Error',error.message + customError ,'Status Code',(<HttpErrorResponse> error).status
      // console.error('HTTP Error', error.message, 'Status Code',(<HttpErrorResponse> error).status);
    }
    else if(error instanceof ErrorEvent){
      errorMessage=' A client-side or network error occurred' ,error.message;
      console.error(' A client-side or network error occurred' , error.message)

    }
    else if(error instanceof TypeError){
      errorMessage='Type Error' ,error.message;
      console.error('Type Error' , error.message)
    }
    else if(error instanceof Error){
      errorMessage='General error' ,error.message;
      console.error('General error', error.message)
    }
    else{
      errorMessage='Error',error.message;
      
    }
    errModal.ErrorMessage=errorMessage;
    console.log(errModal);

    this.InsertErrorDetails(errModal);
    return throwError(errorMessage);

    
}

   InsertErrorDetails(errorDetails: ErrorModel){         
      
     this._repositoryService
     .createWithBody('/api/Error/InsertErrorDetails',errorDetails)
   }

   

}
